export default "__VITE_ASSET__XVCGFoCU__"